export const errorMessages = {
  error: '테스트 에러입니다. 변경하세요.',
  systemError: '오류가 발생했습니다. \n 이 오류가 지속되면 관리자에게 문의하세요',
  statusError: '강제정지된 아이디 입니다. \n 고객센터로 문의해주시기 바랍니다. \n 전자문서 지원센터 02-6000-2155',
  tokenError: '로그인 사용자 정보를 조회하는데 실패했습니다. \n 다시 로그인 해주세요.',
  //pinEmptyYnStateError : 'PIN번호가 설정 되어있지 않습니다. \n PIN번호를 설정 해주세요',
  pinNumState : 'PIN번호가 설정되었습니다. \n 로그인 해주세요',
  passLoginFail : 'PIN번호가 틀립니다. \n 확인해주세요',
  deviceIdLoading : '해당 기기 디바이스아이디가 등록되어 있지 않습니다. \n 관리자에게 문의 해주세요',
  uthInfoFail : '아이디 또는 비밀번호를 확인하시기 바랍니다.\n (비밀번호는 대소문자를 구분합니다.)',
  snsLoginState : 'SNS 로그인이 설정되었습니다.',
  snsLoginStateDelete : 'SNS 로그인 연동이 해제 되었습니다.',
  crtfctLoginState : '공동인증서가 등록 되었습니다.',
  crtfctLoginStateDel : '공동인증서가 삭제 되었습니다.',
  passcrtfctLoginFail : '등록된 인증서가 없습니다.',
  passcrtfctCehckFail : '공동인증서 검증이 실패했습니다.',
}
